import { TabsStateService } from './../../../../shared/services/tabs-state.service';
import { OwnerCardStateService } from './../../../../shared/services/owner-card-state.service';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogModule,
  MatDialogActions,
} from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@jsverse/transloco';
import { CloseOnEscDirective } from '../../../../shared/directive/closeOnEscDirective.directive';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'anihis-info-owner-dialog',
  templateUrl: './info-owner-dialog.component.html',
  standalone: true,
  styleUrls: ['./info-owner-dialog.component.scss'],
  imports: [
    CommonModule,
    MatDialogModule,
    MatDialogActions,
    MatListModule,
    MatDividerModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    TranslocoModule,
    CloseOnEscDirective,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoOwnerDialogComponent {
  dialogRef = inject(MatDialogRef<InfoOwnerDialogComponent>);
  data = inject(MAT_DIALOG_DATA);
  private tabsStateService = inject(TabsStateService);
  private ownerCardStateService = inject(OwnerCardStateService);

  redirectToOwner(animalUid: string, ownerUid: string) {
    this.dialogRef.close({ animalUid: animalUid, ownerUid: ownerUid });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
